'use strict';
var he = require('he');
angular.module('reporting.dashboards.filters')
    .filter('safeHTMLEntities', [
    function () {
        return function (str) {
            // used to replace $sanitize in cases where special characters cannot be
            // encoded as HTML entities
            // ======
            // $sanitize is intended to be used with the bind-html directive, so
            // it creates HTML entities for special characters (&2276; etc.) because
            // those naturally get parsed when they are bound into the DOM.
            //
            // $sanitize will break special characters anywhere that we don't use
            // bind-html, including API requests which means we are storing encoded HTML
            // entities in our persistence layers (noooooo)
            //
            // This filter will return a string with working special characters and all
            // HTML and <script> tags removed.
            // regexes supplied by http://stackoverflow.com/a/9609450
            // lets not try to sanitize anything that isn't a string
            if (str && typeof str === 'string') {
                // strip script/html tags once
                str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
                // decode HTML entities
                str = he.decode(str);
                // this strips any sneaky script/html tags that were parsed into
                // working HTML by reading html entities a few lines above!
                // (nice try, &lt;script type="text/javascript"&gtalert("sucka")&lt;/script&gt; )
                str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            }
            return str;
        };
    }
]);
